import { Component } from '@poa/core';
import { observable, Observer } from '@poa/state';
import React from 'react';
import Navbar from '../components/navbar';
import RouteLoading from '../components/route-loading';
import { ButtonWithLoading } from './daemons.page';
// import { SLIDE_UP, XL } from 'react-ladda';
// import LaddaButton from 'react-ladda';
import { env } from '../env';
import { range } from 'lodash';

import '../styles/components/_archives.scss';

class ReportArchivesList extends React.Component {
  store; // injected by Poa
  actions; // injected by Poa
  env; // injected by Poa
  router; // injected by Poa

  localState = observable({
    selectedMonth: new Date().getMonth() + 1,
    selectedYear: new Date().getFullYear()
  });

  render() {
    const body = this.store.reportArchives.list.map(archive => {
      return (
        <tr key={archive.id}>
          <td style={{ width: '150px' }}>{archive.created_at}</td>
          <td style={{ width: '150px' }}>{archive.month}</td>
          <td style={{ width: '140px' }}>{archive.year}</td>
          <td style={{ width: '140px' }}>{archive.from_date}</td>
          <td style={{ width: '140px' }}>{archive.to_date}</td>
          <td style={{ width: '200px' }}>
            <div className="table-actions">
              <div>
                <ButtonWithLoading
                  type="button"
                  className="filter-columns__save"
                  onClick={async () => {
                    await this.actions.reportArchivesActions.getАссоuntInfoById(archive.id);
                    this.actions.reportArchivesActions.fetch();
                  }}
                >
                  Анкеты
                </ButtonWithLoading>
              </div>
              <div>
                <ButtonWithLoading
                  type="button"
                  className="filter-columns__save"
                  onClick={async () => {
                    await this.actions.reportArchivesActions.getInfoById(archive.id);
                    this.actions.reportArchivesActions.fetch();
                  }}
                >
                  Операторы
                </ButtonWithLoading>
              </div>
              <div>
                <ButtonWithLoading
                  type="button"
                  className="filter-columns__save"
                  onClick={async () => {
                    await this.actions.reportArchivesActions.fetchById(archive.id);
                    this.router.push(`/archives/${archive.id}`);
                  }}
                >
                  Архивы
                </ButtonWithLoading>
              </div>
              <div>
                <ButtonWithLoading
                  type="button"
                  className="filter-columns__save"
                  onClick={async () => {
                    await this.actions.reportArchivesActions.deleteById(archive.id);
                    this.actions.reportArchivesActions.fetch();
                  }}
                >
                  Удалить
                </ButtonWithLoading>
              </div>
            </div>
          </td>
        </tr>
      );
    });

    return (
      <RouteLoading
        meta={{
          hasError: this.store.reportArchives.meta.hasErrorList,
          loaded: this.store.reportArchives.meta.loadedList
        }}
        render={() => (
          <div className="content">
            <Navbar />

            <div className='under-navbar-content'>
              <div>
                <div className="archives__heading">
                  <Observer>
                    {() => (
                      <select
                        value={this.localState.selectedMonth}
                        onChange={({ currentTarget }) =>
                          (this.localState.selectedMonth = +currentTarget.value)
                        }
                      >
                        {Array.from(Array(12).keys()).map(item => {
                          return (
                            <option key={item} value={item + 1}>
                              {item + 1}
                            </option>
                          );
                        })}
                      </select>
                    )}
                  </Observer>

                  <Observer>
                    {() => (
                      <select
                        style={{ marginLeft: 6 }}
                        value={this.localState.selectedYear}
                        onChange={({ currentTarget }) =>
                          (this.localState.selectedYear = +currentTarget.value)
                        }
                      >
                        {range(2015, 2035).map(item => {
                          return (
                            <option key={item} value={item}>
                              {item}
                            </option>
                          );
                        })}
                      </select>
                    )}
                  </Observer>

                  <button
                    className="filter-columns__save"
                    style={{
                      margin: '0 0 0 10px'
                    }}
                    onClick={() => {
                      env.http
                        .get(
                          `payment-info/?month=${this.localState.selectedMonth}&year=${this.localState.selectedYear
                          }`
                        )
                        .then(response => {
                          const pom = document.createElement('a');
                          const csvContent = response.data; //here we load our csv data
                          const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
                          const url = URL.createObjectURL(blob);
                          pom.href = url;
                          pom.setAttribute('download', 'file.csv');
                          pom.click();
                        });
                    }}
                  >
                    Скачать реквизиты для выплат
                  </button>
                </div>

                <div className="container">
                  <div className="inner" />
                  <div className="inner-scroll reports-table">
                    <Observer>
                      {() => (
                        <div className="table-container">
                          <div className="table-container__body">
                            <table className="table" style={{ tableLayout: 'fixed' }}>
                              <thead>
                                <tr>
                                  <th style={{ width: '90px' }}>Дата</th>
                                  <th style={{ width: '150px' }}>Месяц</th>
                                  <th style={{ width: '150px' }}>Год</th>
                                  <th style={{ width: '150px' }}>С даты</th>
                                  <th style={{ width: '150px' }}>По дату</th>
                                  <th style={{ width: '200px', textAlign: 'right' }}>Управление</th>
                                </tr>
                              </thead>
                              <tbody>{body}</tbody>
                            </table>
                          </div>
                        </div>
                      )}
                    </Observer>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      />
    );
  }
}

export default Component({ namespaces: ['common'] })(ReportArchivesList);
